import { ConfirmSheet } from '@/components/ConfirmSheet'
import {
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentTitle,
} from '@/components/ModalSheet'

export interface DeleteBillingMethodDialogProps {
  showing: boolean
  onConfirm: () => void
  onDecline: () => void
}

/**
 * A dialog for confirming the deletion of a billing method.
 */
export function DeleteBillingMethodDialog({
  showing,
  onConfirm,
  onDecline,
}: DeleteBillingMethodDialogProps) {
  return (
    <ConfirmSheet
      danger
      yes="Delete"
      no="Cancel"
      showing={showing}
      onConfirm={onConfirm}
      onDecline={onDecline}
    >
      <ModalSheetContentBlock>
        <ModalSheetContentTitle>Delete Payment Method?</ModalSheetContentTitle>
        <ModalSheetContentDescription>
          Are you sure you want to delete this payment method?
        </ModalSheetContentDescription>
      </ModalSheetContentBlock>
    </ConfirmSheet>
  )
}
